import axios from "axios";
import constants from "../../Constants/constants";
import { COOKIE, getCookie, deleteCookie } from "../Cookie";
import { encodeURI } from "js-base64";
/**
 * @name fetchApi
 * @description will fetch the data based on params supplied
 * @param {string} param
 * @param {string} method
 * @param {object} variables
 */
/**
 * @name fetchStaffApi
 * @description will fetch the data based on params supplied
 * @param {string} param
 * @param {string} method
 * @param {object} variables
 */
//function to fetch student api
export const cookiesToDelete = () => {
	deleteCookie(COOKIE.UserId, "/");
	deleteCookie(COOKIE.UserName, "/");
	deleteCookie(COOKIE.FirstName, "/");
	deleteCookie(COOKIE.MiddleName, "/");
	deleteCookie(COOKIE.LastName, "/");
	deleteCookie(COOKIE.Token, "/");
	deleteCookie(COOKIE.FacultyIdFromEdit, "/");
	deleteCookie(COOKIE.IsActive, "/");
	deleteCookie(COOKIE.IsAdvisor, "/");
	deleteCookie(COOKIE.ReportingTo, "/");
	deleteCookie(COOKIE.Role, "/");
	deleteCookie(COOKIE.IsMentor, "/");
	deleteCookie(COOKIE.SemesterId, "/");
	deleteCookie(COOKIE.PersonalEmail, "/");
	deleteCookie(COOKIE.UniversityEmail, "/");
	deleteCookie(COOKIE.EmailType, "/");
	deleteCookie(COOKIE.NoSemester, "/");
	deleteCookie(COOKIE.HasSurveyPermission, "/");
	sessionStorage.clear();
	localStorage.clear();
}

const getRedirectRoute = () => {
	let route;
	let url = localStorage.getItem('surveyUrl') ? encodeURI(localStorage.getItem('surveyUrl')) : ''
	if (getCookie(COOKIE.Role) !== "0") {
		route = '/staff-login'
	} else {
		route = '/student-login'
	}
	if (url) route += `?${url}`
	return route;
}

export const fetchApi = (param = null, method = null, variables = null) =>
	axios({
		method: method,
		url: `${constants.ApiUrl}${param}`,
		data: variables,
		headers: {
			Authorization: `Bearer ${getCookie(COOKIE.Token)}`
		},
	})
		.then((res) => {
			return res.data;
		})
		.catch((err) => {
			console.log("The Api error", err);
			if (err.response.data.message && err.response.data.status_code) {
				console.log(err.response.data);
			}
			let { status } = err.response;
			let requestPaths = ["/login", "/check-username", "/validate-token", "/get-report"]

			if (status === 401) {
				console.log("Error", err.response.data);
				if (err.response.data.error_message === "Invalid token") {
					cookiesToDelete();
					let route = getRedirectRoute();
					window.location.href = constants.BaseUrl + route;
				}
				if (err.response.data.message) {
					return err.response.data;
				} else if (err.response.data.error_message) {
					return err.response.data;
				} else {
					return false;
				}
			} else if (status === 400) {
				if (err.response.data.message) {
					return err.response.data;
				} else if (err.response.data.error_message) {
					return err.response.data;
				} else {
					return false;
				}
			}
			else if ((status === 403 || status === 429) && requestPaths.includes(param)) {
				if (err.response.data.message) {
					return err.response.data;
				} else if (err.response.data.error_message) {
					return err.response.data;
				} else {
					return false;
				}
			}
			else {
				return false;
			}
		});

export const fetchStaffApi = (param = null, method = null, variables = null, type = null) =>
	axios({
		method: method,
		url: type === 'student' ? `${constants.StudentApiUrl}${param}` : `${constants.StaffApiUrl}${param}`,
		data: variables,
		headers: {
			Authorization: `Bearer ${getCookie(COOKIE.Token)}`
		},
	})
		.then((res) => {
			return res.data;
		})
		.catch((err) => {
			console.log("The Api error", err);
			if (err.response.data.message && err.response.data.status_code) {
				console.log(err.response.data);
			}
			
			let { status } = err.response;
			let requestPaths = ["/get-mail-details", "/get-faculty-list", "/get-faculty-list-id/", "/get-mail-reports"
				, "mail-type", "/get-all-recipients"
			]
			const isMatchedPath = requestPaths?.some(path =>
				param?.startsWith(path)
			);
						console.log(isMatchedPath)

							console.log(429)

			if (status === 401) {
				console.log("Error", err.response.data);
				if (err.response.data.error_message === "Invalid token") {
					cookiesToDelete();
					let route = getRedirectRoute();
					window.location.href = constants.BaseUrl + route;
				}
				if (err.response.data.message) {
					return err.response.data;
				} else {
					return false;
				}
			} else if (status === 400) {
				if (err.response.data.message) {
					return err.response.data;
				} else {
					return false;
				}
			} else if ((status === 403 || status === 429) && isMatchedPath) {
				console.log(429)
				if (err.response.data.message) {
					return err.response.data;
				} else if (err.response.data.error_message) {
					return err.response.data;
				} else {
					return false;
				}
			} else {
				return false;
			}
		});

export const fetchStaffFormData = (url = null, method = null, formData = null, type = null) =>
	axios({
		method,
		url: type === 'student' ? `${constants.StudentApiUrl}${url}` : type === "common" ? `${constants.ApiUrl}${url}` : `${constants.StaffApiUrl}${url}`,
		data: formData,
		headers: {
			Authorization: `Bearer ${getCookie(COOKIE.Token)}`,
			'Content-Type': 'multipart/form-data', // Make sure to set the content type for FormData
		},
	})
		.then((res) => {
			return res.data;
		})
		.catch((err) => {
			console.log("The Api error", err);
			if (err.response.data.message && err.response.data.status_code) {
				console.log(err.response.data);
			}
			let { status } = err.response;
			let requestPaths = ["/student-initial-import", "/student-id-import", "/student-asha-psha-import", "/save-student-record"]
			const isMatchedPath = requestPaths.some(path =>
				url.startsWith(path)
			);
			if (status === 401) {
				console.log("Error", err.response.data);
				if (err.response.data.error_message === "Invalid token") {
					cookiesToDelete();
					let route = getRedirectRoute();
					window.location.href = constants.BaseUrl + route;
				}
				if (err.response.data.message) {
					return err.response.data;
				} else {
					return false;
				}
			} else if (status === 400) {
				if (err.response.data.message) {
					return err.response.data;
				} else {
					return false;
				}
			} else if ((status === 403 || status === 429) && isMatchedPath) {
				if (err.response.data.message) {
					return err.response.data;
				} else if (err.response.data.error_message) {
					return err.response.data;
				} else {
					return false;
				}
			} else {
				return false;
			}
		});

export const fetchStaffDownloadApi = (param = null, method = null, variables = null) =>
	axios({
		method: method,
		url: `${constants.StaffApiUrl}${param}`,
		data: variables,
		headers: {
			Authorization: `Bearer ${getCookie(COOKIE.Token)}`
		},
		responseType: 'blob'
	})
		.then(async (res) => {
			if (res?.headers?.['content-type']?.includes('application/json')) {
				const text = await res?.data.text();
				const data = JSON.parse(text);
				return data
			}
			return res.data;
		})
		.catch((err) => {
			console.log("The Api error", err);
			if (err.response.data.message && err.response.data.status_code) {
				console.log(err.response.data);
			}
			let { status } = err.response;
			if (status === 401) {
				console.log("Error", err.response.data);
				if (err.response.data.error_message === "Invalid token") {
					cookiesToDelete();
					let route = getRedirectRoute();
					window.location.href = constants.BaseUrl + route;
				}
				if (err.response.data.message) {
					return err.response.data;
				} else {
					return false;
				}
			} else if (status === 400) {
				if (err.response.data.message) {
					return err.response.data;
				} else {
					return false;
				}
			} else {
				return false;
			}
		});

export const fetchDownloadApi = (param = null, method = null, variables = null) =>
	axios({
		method: method,
		url: `${constants.ApiUrl}${param}`,
		data: variables,
		headers: {
			Authorization: `Bearer ${getCookie(COOKIE.Token)}`
		},
		responseType: 'blob'
	})
		.then(async (res) => {
			if (res?.headers?.['content-type']?.includes('application/json')) {
				const text = await res?.data.text();
				const data = JSON.parse(text);
				return data
			}
			return res.data;
		})
		.catch((err) => {
			console.log("The Api error", err);
			if (err.response.data.message && err.response.data.status_code) {
				console.log(err.response.data);
			}
			let { status } = err.response;
			if (status === 401) {
				console.log("Error", err.response.data);
				if (err.response.data.error_message === "Invalid token") {
					cookiesToDelete();
					let route = getRedirectRoute();
					window.location.href = constants.BaseUrl + route;
				}
				if (err.response.data.message) {
					return err.response.data;
				} else {
					return false;
				}
			} else if (status === 400) {
				if (err.response.data.message) {
					return err.response.data;
				} else {
					return false;
				}
			} else {
				return false;
			}
		});
